import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { FAQ } from './FAQ';
export function Guarantee() {
  // ✅ Anti doble click (para no disparar 2 veces)
  const [isRedirecting, setIsRedirecting] = useState(false);
  const handleClick = () => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    const variantId = '53162996171116';

    // ✅ Track AddToCart (intención)
    try {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          content_ids: [variantId],
          content_type: 'product',
          value: 14.99,
          currency: 'USD'
        });
      }
    } catch {}

    // ✅ Mantener UTMs y FORZAR volver al carrito
    const qs = (window.location.search || '').replace(/^\?/, '');
    const returnTo = qs ? `/cart?${qs}` : '/cart';

    // ✅ /cart/add + return_to (evita que se salte el carrito)
    const url = `https://sanarconsciente.com/cart/add` + `?id=${encodeURIComponent(variantId)}` + `&quantity=1` + `&return_to=${encodeURIComponent(returnTo)}`;
    window.location.href = url;
  };
  return <>
      <section className="w-full bg-[var(--bg-dark)] py-8 md:py-12 px-4" data-id="element-134">
        <div className="max-w-4xl mx-auto" data-id="element-135">
          {/* Main Heading */}
          <div className="text-center mb-6 md:mb-8" data-id="element-136">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-[var(--text-light)] mb-2" data-id="element-137">
              NO DIGAS "SÍ". SOLO DÍ "QUIZÁS" &{' '}
              <span className="text-[var(--accent-orange)]" data-id="element-138">
                PRUÉBALO SIN RIESGO
              </span>
            </h2>
            <p className="text-base md:text-lg text-[var(--text-gray)] mt-3" data-id="element-139">
              No te daré una "garantía" vacía. Te hago una promesa personal 🤍:
            </p>
          </div>

          {/* Guarantee Card */}
          <div className="bg-[var(--bg-card)] rounded-2xl p-4 md:p-6 lg:p-8 border-2 border-[var(--accent-orange)] mb-6" data-id="element-140">
            <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-center justify-start" data-id="element-141">
              <div className="flex-shrink-0" data-id="element-142">
                <div className="w-16 h-16 md:w-20 md:h-20 bg-[var(--accent-orange)]/10 rounded-full flex flex-row items-center justify-center" data-id="element-143">
                  <ShieldCheckIcon className="w-10 h-10 md:w-12 md:h-12 text-[var(--accent-orange)]" aria-hidden="true" data-id="element-144" />
                </div>
              </div>

              <div className="flex-1" data-id="element-145">
                <h3 className="md:text-2xl lg:text-3xl font-black text-[var(--text-light)] mb-3 text-[14px]" data-id="element-146">
                  GARANTÍA DE 120 DÍAS: "ÁMALO O DÉJALO" — 100% SATISFACCIÓN
                </h3>

                <div className="space-y-2 text-sm md:text-base lg:text-lg text-[var(--text-gray)]" data-id="element-147">
                  <p data-id="element-148">
                    Si este no es el recurso de Jabones Artesanales más completo
                    que hayas visto, escríbeme y Sin preguntas. Sin letra
                    pequeña. Sin condiciones. Te devolveré tu dinero.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="text-center" data-id="element-149">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-black text-[var(--accent-orange)] mb-3 md:mb-4" data-id="element-150">
              Pero Atención
            </h3>
            <p className="text-base md:text-xl lg:text-2xl text-[var(--text-light)] mb-2 md:mb-3" data-id="element-151">
              No mantendré este precio para siempre.
            </p>
            <p className="text-sm md:text-base lg:text-lg text-[var(--text-gray)] mb-3 md:mb-4" data-id="element-152">
              Me reservo el derecho de subirlo o cerrar el acceso cuando lo
              considere.
            </p>
            <p className="text-base md:text-xl lg:text-2xl font-bold text-[var(--text-light)] mb-4 md:mb-6" data-id="element-153">
              Porque este no es un hobby barato.
              <br data-id="element-154" />
              <span className="text-[var(--accent-orange)]" data-id="element-155">
                Es una habilidad que puede convertirse en ingreso real.
              </span>
            </p>

            <div className="space-y-2 md:space-y-3 mb-6 md:mb-8 text-sm md:text-base lg:text-lg text-[var(--text-gray)]" data-id="element-156">
              <p data-id="element-157">Si quieres dejar de improvisar…</p>
              <p data-id="element-158">Si quieres empezar con seguridad…</p>
              <p data-id="element-159">Si quieres tener un sistema claro…</p>
            </div>

            <p className="text-lg md:text-2xl lg:text-3xl font-bold text-[var(--text-light)] mb-5 md:mb-6" data-id="element-160">
              Haz clic abajo y empieza hoy mismo.
            </p>

            <button onClick={handleClick} className="bg-[var(--accent-orange)] hover:bg-[var(--accent-orange-hover)] text-white font-bold px-12 py-5 text-xl md:text-2xl rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl uppercase tracking-wide flex items-center justify-center gap-3 mx-auto" data-id="element-161">
              <ShieldCheckIcon className="w-6 h-6 md:w-7 md:h-7" aria-hidden="true" data-id="element-162" />
              EMPEZAR AHORA
            </button>

            <p className="text-base md:text-xl lg:text-2xl text-[var(--accent-orange-light)] font-bold mt-5 md:mt-6" data-id="element-163">
              Tu primer lote exitoso está más cerca de lo que crees.
            </p>
          </div>
        </div>
      </section>

      <FAQ data-id="element-164" />
    </>;
}